import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { Logo } from "@/components/Logo";
import { nav, legalLinks, site } from "@/config/site";
import { services } from "@/data/services";

export const Footer = () => {
  const year = new Date().getFullYear();
  const openCookies = () => window.dispatchEvent(new CustomEvent("mdp:open-cookies"));
  return (
    <footer className="relative border-t border-line-dark bg-night text-white" data-testid="site-footer">
      <div className="container-x grid gap-12 py-16 lg:grid-cols-12 lg:gap-8 lg:py-20">
        <div className="lg:col-span-4">
          <Logo light />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60">{site.tagline}</p>
          <ul className="mt-8 space-y-3 text-sm text-white/80">
            <li className="flex gap-3"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" /><span>{site.address.full}</span></li>
            <li className="flex gap-3"><Phone className="mt-0.5 h-4 w-4 shrink-0 text-gold" /><a href={site.phoneHref} className="hover:text-gold" data-testid="footer-phone-link">{site.phone}</a></li>
            <li className="flex gap-3"><Mail className="mt-0.5 h-4 w-4 shrink-0 text-gold" /><a href={site.emailHref} className="hover:text-gold" data-testid="footer-email-link">{site.email}</a></li>
            <li className="flex gap-3"><Clock className="mt-0.5 h-4 w-4 shrink-0 text-gold" /><span>{site.hours}</span></li>
          </ul>
        </div>
        <div className="lg:col-span-2 lg:col-start-6">
          <h2 className="text-[11px] font-semibold uppercase tracking-[0.22em] text-gold">Navigation</h2>
          <ul className="mt-5 space-y-3 text-sm">
            {nav.map((n) => (<li key={n.to}><Link to={n.to} className="text-white/75 transition-colors hover:text-white">{n.label}</Link></li>))}
            <li><Link to="/contact#devis" className="text-white/75 transition-colors hover:text-white">Demander un devis</Link></li>
          </ul>
        </div>
        <div className="lg:col-span-3">
          <h2 className="text-[11px] font-semibold uppercase tracking-[0.22em] text-gold">Services</h2>
          <ul className="mt-5 space-y-3 text-sm">
            {services.map((s) => (<li key={s.slug}><Link to={`/services#${s.slug}`} className="text-white/75 transition-colors hover:text-white">{s.title}</Link></li>))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <h2 className="text-[11px] font-semibold uppercase tracking-[0.22em] text-gold">Informations légales</h2>
          <ul className="mt-5 space-y-3 text-sm">
            {legalLinks.map((n) => (<li key={n.to}><Link to={n.to} className="text-white/75 transition-colors hover:text-white" data-testid={`footer-link-${n.to.slice(1)}`}>{n.label}</Link></li>))}
            <li><button type="button" onClick={openCookies} className="text-white/75 transition-colors hover:text-white" data-testid="footer-manage-cookies-btn">Gérer mes cookies</button></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x flex flex-col gap-3 py-6 text-xs text-white/50 md:flex-row md:items-center md:justify-between">
          <p data-testid="footer-legal-line">
            © {year} {site.name} — {site.legalFormShort} au capital de {site.capital} — {site.rcs} — EUID {site.euid}
          </p>
          <p>Site hébergé par Namecheap</p>
        </div>
      </div>
    </footer>
  );
};
